import log from '../../helpers/Logger';
import { isDevelopment } from '../../helpers/Environment';

export default function () {
  // Set logging level
  log.setLevel(isDevelopment() ? 'debug' : 'warn');
}
